import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useMergingListUIContext } from "./MergingListUIContext";
import MergingListTable from "./mergingList-table/MergingListTable";
import { MergingListFilter } from "./mergingList-filter/MergingListFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const MergingListCard = () => {
  const mergingListUIContext = useMergingListUIContext();
  const mergingListUIProps = useMemo(() => {
    return {
      newMergingListButtonClick: mergingListUIContext.newMergingListButtonClick,
    };
  }, [mergingListUIContext]);

  return (
    <Card>
      <CardHeader title="Daftar Sisa Merging" />
      <CardBody>
        {/* <MergingListFilter /> */}
        <MergingListTable />
      </CardBody>
    </Card>
  );
};
